/* src/app/modules_v2/booking/components/booking-list/booking-list.component.css */
/*# sourceMappingURL=booking-list.component.css.map */
